import { Box, Typography } from '@mui/material';
import { analyticsColors } from './analyticsStyles';
import type { SalesGranularity } from './salesAnalyticsUtils';

interface Props {
  value: SalesGranularity;
  onChange: (value: SalesGranularity) => void;
  availableViews: SalesGranularity[];
}

const OPTIONS: { value: SalesGranularity; label: string }[] = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'biweekly', label: 'Bi-Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const SalesPeriodToggle = ({ value, onChange, availableViews }: Props) => {
  const visibleOptions = OPTIONS.filter((opt) =>
    availableViews.includes(opt.value)
  );

  if (visibleOptions.length <= 1) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        bgcolor: analyticsColors.toggleBg,
        borderRadius: '999px',
        p: '4px',
      }}
    >
      {visibleOptions.map((opt) => {
        const active = value === opt.value;
        return (
          <Box
            key={opt.value}
            onClick={() => onChange(opt.value)}
            sx={{
              px: 2.25,
              py: 0.625,
              borderRadius: '999px',
              cursor: 'pointer',
              userSelect: 'none',
              bgcolor: active ? analyticsColors.toggleActiveBg : 'transparent',
              border: `1.5px solid ${
                active ? analyticsColors.toggleActiveBorder : 'transparent'
              }`,
              transition: 'all 0.2s ease',
            }}
          >
            <Typography
              sx={{
                fontSize: '0.8125rem',
                fontWeight: active ? 600 : 500,
                color: active ? analyticsColors.title : analyticsColors.subtitle,
                lineHeight: 1.2,
              }}
            >
              {opt.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
